export default __webpack_public_path__ + "media/images/casatb/tenant/banner-two-6ab84efedcf91a078bb7a4279e67270d.png";